// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__19YjR","log":"ModalInventoryLogs_log__3chl8","date":"ModalInventoryLogs_date__BVsHX","userName":"ModalInventoryLogs_userName__fa7ya"};